import { PageConfig } from "../../config/page-configs/page-configs";
import { MesosFeatureButtonId } from "../../config/mesos-config";
import { unique } from "./cookie-helpers";

export const LSKA = "tcbAT";
export const LSKF = "tcbF";

export const getSessionStorage = (SessionStorageKey: string) => {
    const item = sessionStorage.getItem(SessionStorageKey);
    return item ? JSON.parse(item) : null;
};

export const setSessionStorage = (SessionStorageKey: string, values: any) => {
    sessionStorage.setItem(SessionStorageKey, JSON.stringify(values));
};

export const setExpiringSessionStorage = (
    SessionStorageKey: string,
    values: any,
    date: Date
) => {
    const expirationItem = {
        value: values,
        expires: date.toISOString(),
    };
    sessionStorage.setItem(SessionStorageKey, JSON.stringify(expirationItem));
};

export const getFeatures = (pageConfig: PageConfig): MesosFeatureButtonId[] =>
    pageConfig.welcome.buttons.map((btn) => btn.mesosId);

export const getSeenAlertTexts = (): string[] => {
    const SessionStorageItem = getSessionStorage(LSKA);
    return SessionStorageItem || [];
};

export const getSeenFeatures = (): string[] => {
    const SessionStorageItem = getSessionStorage(LSKF);
    return SessionStorageItem || [];
};

export const setSeenAlertText = (pageConfig: PageConfig) => {
    setSessionStorage(
        LSKA,
        [...getSeenAlertTexts(), pageConfig.alert.id].filter(unique)
    );
};

export const setSeenFeatures = (pageConfig: PageConfig) => {
    setSessionStorage(
        LSKF,
        [...getSeenFeatures(), ...getFeatures(pageConfig)].filter(unique)
    );
};

export const hasUnseenAlertText = (pageConfig: PageConfig): boolean =>
    !getSeenAlertTexts().includes(pageConfig.alert.id);

export const hasUnseenFeatures = (pageConfig: PageConfig): boolean => {
    const seenFeatures = getSeenFeatures();
    let newFeature = false;
    for (const feature of getFeatures(pageConfig)) {
        if (!seenFeatures.includes(feature)) {
            newFeature = true;
            break;
        }
    }
    return newFeature;
};

export const hasURIPart = (serachURL: string): boolean => {
    return window.location.href.indexOf(serachURL) !== -1 ? true : false;
}

export const isDomainAndHasSessionStorage = (): boolean => {
    const windowLoc = window.location.href.includes("localhost");
    const SessionStorageItem = document.cookie.indexOf("cookie_consent=") !== -1 ? true : windowLoc;
    const SessionStorageExist = hasURIPart("arbeitsagentur.de") ? SessionStorageItem : true;
    const isMobileDevice = window.matchMedia("only screen and (max-width: 760px)").matches;
    const allowed = isMobileDevice ? !isMobileDevice : SessionStorageExist;
    // console.log(isMobileDevice, allowed, SessionStorageExist)
    return allowed;
};

export const shouldAlertOpen = (pageConfig: PageConfig) => {
    const allowedPopUp = isDomainAndHasSessionStorage() && !hasURIPart("-ui");
    if (allowedPopUp) {
        return hasUnseenFeatures(pageConfig) || hasUnseenAlertText(pageConfig);
    } else {
        return false;
    }
};

export const preventSameAlert = (pageConfig: PageConfig) => {
    setSeenFeatures(pageConfig);
    setSeenAlertText(pageConfig);
};
